<template>
    <div label="模板统计" name="statistics">
          <div class="padding15-tb">
            <el-form size="small" label-width="100px">
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="标签">
                    <el-select v-model="statistics.company" placeholder="请选择" style="width: 100%;">
                      <el-option
                        v-for="item in statistics.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="案件导入时间">
                    <el-date-picker style="width: 100%;"
                      v-model="statistics.importTime"
                      type="daterange"
                      align="right"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-button type="primary" size="small" plain> <i class="fa fa-search"></i> 搜索</el-button>
                  <el-button size="small">重置</el-button>
                </el-col>
              </el-row>
            </el-form>
            <el-alert
              title="最近更新时间 : 2018-06-28 02:04:14"
              type="info">
            </el-alert>
          </div>
          <div class="paddding15-tb">
            <el-table
              :data="tableData6"
              :span-method="objectSpanMethod"
              size="small"
              border
              style="width: 100%; margin-top: 20px">
              <el-table-column
                prop="id"
                label="ID"
                width="180">
              </el-table-column>
              <el-table-column
                prop="name"
                label="姓名">
              </el-table-column>
              <el-table-column
                prop="amount1"
                label="数值 1（元）">
              </el-table-column>
              <el-table-column
                prop="amount2"
                label="数值 2（元）">
              </el-table-column>
              <el-table-column
                prop="amount3"
                label="数值 3（元）">
              </el-table-column>
            </el-table>
          </div>
          <div class="text center margin15-tb">
            <el-pagination
            background
              layout="prev, pager, next, sizes, jumper"
              :total="1000">
            </el-pagination>
          </div>
    </div>
</template>
<script>
import { data3, data5 } from './reportData';

export default {
  // props: [
  //   'changeTabe'
  // ],
  // watch: {
  //   changeTabe(type) {
  //     if (type === 'statistics') {
  //       this.reportData = data3;
  //     }
  //   }
  // },
  data() {
    return {
      activeTab: 'report',
      statistics: {
        company: '',
        importTime: '',
        options: [
          {
            value: '选项1',
            label: '黄金糕'
          }, {
            value: '选项2',
            label: '双皮奶'
          }, {
            value: '选项3',
            label: '蚵仔煎'
          }, {
            value: '选项4',
            label: '龙须面'
          }, {
            value: '选项5',
            label: '北京烤鸭'
          }
        ]
      },
      reportSearchOptions: {},
      reportDisplayDays: 3,
      displayFieldsVisible: false,
      display: {
        company: true,
        importTime: true,
        group: true,
        batchNo: false,
        days: false,
        collectionDays: false,
        overdueDays: false,
        averageMoney: true,
        messageCount: false,
        ivrCount: false
      },
      reportData: [],
      tableData6: [
        {
          id: '12987122',
          name: '王小虎',
          amount1: '234',
          amount2: '3.2',
          amount3: 10
        }, {
          id: '12987123',
          name: '王小虎',
          amount1: '165',
          amount2: '4.43',
          amount3: 12
        }, {
          id: '12987124',
          name: '王小虎',
          amount1: '324',
          amount2: '1.9',
          amount3: 9
        }, {
          id: '12987125',
          name: '王小虎',
          amount1: '621',
          amount2: '2.2',
          amount3: 17
        }, {
          id: '12987126',
          name: '王小虎',
          amount1: '539',
          amount2: '4.1',
          amount3: 15
        }
      ]
    };
  },
  mounted() {
    this.reportData = data3;
  },
  methods: {
    fetch() {
      this.reportDisplayDays = 5;
      this.reportData = data5;
    },
    handleClick() {},
    objectSpanMethod() {
    }
  }
};
</script>
<style lang="less" scoped>
.display-field-wrapper {
  padding-left: 100px;
  .display-fields-options {
    background: #f7f7f7;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main/collection/report/templateReport.vue